"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_components_1 = require("styled-components");

var React = require("react");

var zIndex_1 = require("../../../systems/zIndex");

var StyledMobileNavigation = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  z-index: ", ";\n  @media only screen and (min-width:768px) {\n    display: none;\n  }\n"], ["\n  z-index: ", ";\n  @media only screen and (min-width:768px) {\n    display: none;\n  }\n"])), zIndex_1.default.Header);

var MobileNavigation = function MobileNavigation(props) {
  return React.createElement(StyledMobileNavigation, null, props.children);
};

exports.default = MobileNavigation;
var templateObject_1;